import { ChangeDetectionStrategy, Component, HostListener, Input, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';

import type { SitePageEntity } from '@common/types/site-page.type';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-delete-page-modal',
    templateUrl: './delete-page-modal.component.html',
    styleUrls: ['./delete-page-modal.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule],
})
export class DeletePageModalComponent {
    private readonly bsModalRef = inject(BsModalRef);

    @Input() public page!: SitePageEntity;

    public onClose: Subject<boolean> = new Subject();

    public onConfirm(): void {
        this.onClose.next(true);
        this.bsModalRef.hide();
    }

    public onCancel(): void {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }

    public onCloseModal(): void {
        this.bsModalRef.hide();
    }

    @HostListener('document:keydown.enter', ['$event'])
    public enterKeyEvent(event: KeyboardEvent): void {
        event.stopPropagation();
        this.onConfirm();
    }
}
